import React from 'react'
import HeroSection from '../HeroSection/Herosection'
import Trusted from '../Trusted/Trusted'
import AboutUs from '../AboutUs/AboutUs'
import Services from '../Services/Services'
import Commitment from '../Commitment/Commitment'
import Companies from '../Companies/Companies'
import Faq from '../Faq/Faq'
import ContactUs from '../Contact/ContactUs'
import Banner from '../Banner/Banner'
import Footer from '../Footer/Footer'

import { heroText, aboutText, contactText, bannerText,} from '../Data'


const Home = () => {

  return (
    <div>
      <HeroSection {...heroText}/>
      <Trusted />
      <AboutUs {...aboutText} />
      <Services />
      <Commitment/>
      <Companies/>
      <Faq/>
      <ContactUs {...contactText}/>
      <Banner {...bannerText}/>
      <Footer/>


    </div>
  )
}

export default Home
